import dayjs from 'dayjs';
import { BUSINESS_DETAILS, CONFIGURATION_CONSTANTS, REGEX, SELLER_PROFILE } from '../constants/constants';
import { s_a, state_arr } from './cities';

export function validateQuote(quoteObject: any) {
  // console.log(quoteObject);
  const quoteName = quoteObject.name;
  const rfqId = quoteObject.requestId || quoteObject.quoteId;
  const quoteItems = quoteObject.items;

  const errorItems = [];
  if (quoteName === '' || !isValidStringInput(quoteName)) {
    const errorItem = {
      elementId: 'name',
      message: 'Invalid quote name',
    };
    errorItems.push(errorItem);
  }
  if (rfqId == '' || !rfqId.match(REGEX.inputStringGeneralCharacters)) {
    const errorItem = {
      elementId: 'requestId',
      message: 'Invalid request Id',
    };
    errorItems.push(errorItem);
  }

  if (quoteItems && quoteItems.length > 0) {
    let hasValidValueItems = false;
    quoteItems.forEach((quoteItem: any, index: number) => {
      if (quoteItem.pricePerUnit <= 0 && quoteItem.gst > 0) {
        const errorItem = {
          elementId: `pricePerUnit_${index + 1}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      } else if (quoteItem.gst < 0 && quoteItem.pricePerUnit > 0) {
        const errorItem = {
          elementId: `gst_${index + 1}`,
          message: 'Invalid item GST',
        };
        errorItems.push(errorItem);
      }else if(quoteItem.pricePerUnit > 0 && quoteItem.gst>=0){
        hasValidValueItems = true
      }
    });
    if(!hasValidValueItems){
      const errorItem = {
        elementId: `items_div`,
        message: 'Please enter pricing of atleast 1 item',
      };
      errorItems.push(errorItem);
    }
  } else if (quoteItems.length <= 0 && quoteObject.excelFilePath === '') {
    const errorItem = {
      elementId: 'itemsDiv',
      message: 'Invalid quote items',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

export function validateOrder(orderObject: any) {
  // console.log(quoteObject);
  const orderName = orderObject.orderName;
  const orderItems = orderObject.items;
  const expectedDeliveryDate = orderObject.expectedDeliveryDate;

  const errorItems = [];
  if (orderName === '' || !isValidStringInput(orderName)) {
    const errorItem = {
      elementId: 'orderName',
      message: 'Invalid order name',
    };
    errorItems.push(errorItem);
  }

  if (expectedDeliveryDate === '') {
    const errorItem = {
      elementId: 'expectedDeliveryDate',
      message: 'Invalid delivery date',
    };
    errorItems.push(errorItem);
  }
  
  if (orderItems && orderItems.length > 0) {
    let hasValidValueItems = false;
    orderItems.forEach((orderItem: any, index: number) => {

      const quantSplit = orderItem?.quantity?.toString()?.split('.');
      const ppuSplit = orderItem?.pricePerUnit?.toString()?.split('.');

      if (!orderItem.item  || orderItem.item.trim() == "") {
        const errorItem = {
          elementId: `item_${index}`,
          message: 'Invalid item',
        };
        errorItems.push(errorItem);
      }
      // else if (!orderItem.hsnCode || orderItem.hsnCode == "") {
      //   const errorItem = {
      //     elementId: `hsnCode_${index}`,
      //     message: 'Invalid item hsn',
      //   };
      //   errorItems.push(errorItem);
      // }
      else if (!orderItem.quantity  || isNaN(orderItem.quantity) || orderItem.quantity <= 0) {
        const errorItem = {
          elementId: `quantity_${index}`,
          message: 'Invalid item quantity',
        };
        errorItems.push(errorItem);
      }
      else if (orderItem.pricePerUnit <= 0 && orderItem.gst > 0) {
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      } else if (orderItem.gst < 0 && orderItem.pricePerUnit > 0) {
        const errorItem = {
          elementId: `gst_${index}`,
          message: 'Invalid item GST',
        };
        errorItems.push(errorItem);
      }
      else if(orderItem.pricePerUnit > 0 && orderItem.gst>=0){
        hasValidValueItems = true
      }
      if ( isNaN(orderItem?.pricePerUnit) || (ppuSplit?.length > 1 && ppuSplit[1].length === 0) ){
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      }
      if ( isNaN(orderItem?.quantity) || (quantSplit?.length > 1 && quantSplit[1].length === 0) ){
        const errorItem = {
          elementId: `quantity_${index}`,
          message: 'Invalid item quantity',
        };
        errorItems.push(errorItem);
      }
    });
    // if(!hasValidValueItems){
    //   const errorItem = {
    //     elementId: `items_div`,
    //     message: 'Please enter pricing of atleast 1 item',
    //   };
    //   errorItems.push(errorItem);
    // }
  } else if (orderObject.length <= 0 && orderObject.excelFilePath === '') {
    const errorItem = {
      elementId: 'itemsDiv',
      message: 'Invalid order items',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

export function validateRequest(requestObject: any, expectedQuoteDate: any, expectedDeliveryDate: any,
  validateDetail: boolean, validateItem: boolean,validUOM:any, validCategories:any, selectedCategories: any = {}) {
    // console.log(validUOM,validCategories)
  const errorItems = [];
  
  if (validateDetail) {

    if(selectedCategories){
      let valid = true;
      const validCategoryId = validCategories?.map((category: any)=> category?._id)
      Object.keys(selectedCategories)?.forEach((category)=>{
        if(selectedCategories[category] && !validCategoryId?.includes(category)){
          valid = false;
        }
      })
      if(!valid){
        const errorItem = {
          elementId : 'categoryList',
          message: 'One or more invalid categories selected'
        }
        errorItems.push(errorItem)
      }
    }

    const requestName = requestObject.name;
    // const description = requestObject.description;
    const paymentTerms = requestObject.paymentTerms;

    if (
      requestName == '' || !isValidStringInput(requestName)
    ) {
      const errorItem = {
        elementId: 'name',
        message: 'Invalid RFQ name',
      };
      errorItems.push(errorItem);
    }

    if(!expectedQuoteDate){
      const errorItem = {
        elementId: 'expectedQuoteDate',
        message: 'Invalid bid end date',
      };
      errorItems.push(errorItem);
    }

    if(!expectedDeliveryDate){
      const errorItem = {
        elementId: 'expectedDeliveryDate',
        message: 'Invalid expected delivery date',
      };
      errorItems.push(errorItem);
    }

    // if (description != "" && !isValidStringInput(description)) {
    //   const errorItem = {
    //     elementId: 'description',
    //     message: 'Invalid description',
    //   };
    //   errorItems.push(errorItem);
    // }

    if (paymentTerms != "" && !isValidStringInput(paymentTerms)) {
      const errorItem = {
        elementId: 'paymentTerms',
        message: 'Invalid payment terms',
      };
      errorItems.push(errorItem);
    }
  }

  if (validateItem) {
    const rfqItems = requestObject;
    if (rfqItems && rfqItems.length > 0) {
      rfqItems.forEach((rfqItem: any, index: number) => {
        if (rfqItem.itemName == "" || !isValidStringInput(rfqItem.itemName) || !rfqItem.itemName) {
          const errorItem = {
            elementId: `itemName_${index}`,
            message: 'Invalid item name',
          };
          errorItems.push(errorItem);
        }

        // if (rfqItem?.itemType !== "" && ( rfqItem.itemType && !isValidStringInput(rfqItem.itemType) || !rfqItem.itemType || !checkValidItemType(rfqItem.itemType,validCategories))) {
        //   const errorItem = {
        //     elementId: `itemType_${index}`,
        //     message: 'Invalid category',
        //   };
        //   errorItems.push(errorItem);
        // }

        if (rfqItem.brandName != "" && !isValidStringInput(rfqItem.brandName)) {
          const errorItem = {
            elementId: `brandName_${index}`,
            message: 'Invalid make',
          };
          errorItems.push(errorItem);
        }

        if (rfqItem.itemSize != "" && !isValidStringInput(rfqItem.itemSize)) {
          const errorItem = {
            elementId: `itemSize_${index}`,
            message: 'Invalid specification',
          };
          errorItems.push(errorItem);
        }
        if (rfqItem.quantityUOM == "" || !isValidStringInput(rfqItem.quantityUOM) || !rfqItem.quantityUOM || !checkValidUOM(rfqItem.quantityUOM,validUOM)) {
          const errorItem = {
            elementId: `quantityUOM_${index}`,
            message: 'Invalid UOM',
          };
          errorItems.push(errorItem);
        }

        if (!rfqItem.quantity || rfqItem.quantity <= 0 || isNaN(Number(rfqItem.quantity))) {
          const errorItem = {
            elementId: `quantity_${index}`,
            message: 'Invalid quantity',
          };
          errorItems.push(errorItem);
        }
      });
    } else if (!rfqItems || rfqItems.length <= 0) {
      const errorItem = {
        elementId: 'itemsDiv',
        message: 'Invalid RFQ items',
      };
      errorItems.push(errorItem);
    }
  }

  return errorItems;
}

export function validateROItems(items: any){
  let errorItems:any[] = []
  let fiveDec = ["Feet", "Gm", "KG", "Length", "LTR", "MTR", "SQF", "SQM", "Ton"]
  items.forEach((item: any, index: number)=>{
    // console.log(item)
    if (!item.quantity || item.quantity <= 0 || isNaN(Number(item.quantity))) {
      const errorItem = {
        elementId: `quantity_${item?._id}`,
        message: 'Invalid quantity',
      };
      errorItems.push(errorItem);
    }
    if (!item.finalUnitPrice || item.finalUnitPrice <= 0 || isNaN(Number(item.finalUnitPrice))) {
      const errorItem = {
        elementId: `finalUnitPrice_${item?._id}`,
        message: 'Invalid quantity',
      };
      errorItems.push(errorItem);
    }
    if (item.finalUnitPrice>10000000000) {
      const errorItem = {
        elementId: `finalUnitPrice_${item?._id}`,
        message: 'Maximum price can be 100 Cr',
      };
      errorItems.push(errorItem);
    }
    if (item.quantity>=1000000) {
      const errorItem = {
        elementId: `quantity_${item?._id}`,
        message: 'Quantity should be lesser than 10 Lakhs',
      };
      errorItems.push(errorItem);
    }
    // console.log(item?.quantity.toString()?.split('.')?.[1])
    // if ( fiveDec?.includes(item?.quanityUOM) && item?.quantity.toString()?.split('.')?.[1]?.length>5) {
    //   const errorItem = {
    //     elementId: `quantity_${item?._id}`,
    //     message: `Maximum precision allowed is upto 5 places for ${item?.quanityUOM}`,
    //   };
    //   errorItems.push(errorItem);
    // }
    // else if (item?.quantity.toString()?.split('.')?.[1]?.length>2) {
    //   const errorItem = {
    //     elementId: `quantity_${item?._id}`,
    //     message: `Maximum precision allowed is upto 2 places for ${item?.quanityUOM}`,
    //   };
    //   errorItems.push(errorItem);
    // }
  })
  return errorItems;
}
export function validateCloneROInfo(reqBody: any){
  let errorItems:any[] = []
  // referenceDate: customPODate,
  // referenceNumber: customPONum || "",
  // poDeliveryDate: poDeliveryDate,
  // termsAndConditions: tnc,
  // paymentTerms: paymentTerms
  if (!dayjs(reqBody?.referenceDate).isValid()) {
    const errorItem = {
      elementId: `referenceDate`,
      message: 'Invalid Date',
    };
    errorItems.push(errorItem);
  }
  if (!dayjs(reqBody?.poDeliveryDate).isValid() || (dayjs(reqBody?.poDeliveryDate).isBefore(dayjs(new Date()), "day"))) {
    const errorItem = {
      elementId: `poDeliveryDate`,
      message: 'Invalid Date',
    };
    errorItems.push(errorItem);
  }
  if (reqBody?.referenceNumber && (!isValidStringInput(reqBody?.referenceNumber))) {
    const errorItem = {
      elementId: `referenceNumber`,
      message: 'Invalid PO Number',
    };
    errorItems.push(errorItem);
  }
  if (reqBody?.paymentTerms && (!isValidStringInput(reqBody?.paymentTerms))) {
    const errorItem = {
      elementId: `paymentTerms`,
      message: 'Invalid Payment Terms',
    };
    errorItems.push(errorItem);
  }
  if (reqBody?.termsAndConditions && (!isValidStringInput(reqBody?.termsAndConditions))) {
    const errorItem = {
      elementId: `termsAndConditions`,
      message: 'Invalid Terms and Conditions',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

export function validateConfiguration(bankDetails: any, party: any, prefPayment: any, roValue: any, poSequence: any, prefTerms: any, prefBid: any){ 
  let errorItems = []
  if (bankDetails && (bankDetails["accountHolderName"] == "" || !isValidStringInput(bankDetails["accountHolderName"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER,
      message: 'Invalid Account Holder',
    };
    errorItems.push(errorItem);
  }
  if (bankDetails && (bankDetails["accountNumber"] == "" || !isValidStringInput(bankDetails["accountNumber"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_NUMBER,
      message: 'Invalid Account Number',
    };
    errorItems.push(errorItem);
  }
  if (bankDetails && (bankDetails["bankName"] == "" || !isValidStringInput(bankDetails["bankName"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.ACCOUNT_HOLDER,
      message: 'Invalid Bank Name',
    };
    errorItems.push(errorItem);
  }
  if (bankDetails && (bankDetails["ifscCode"] == "" || !isValidStringInput(bankDetails["ifscCode"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.BANK_NAME,
      message: 'Invalid IFSC Code',
    };
    errorItems.push(errorItem);
  }
  if (party && (party["gstNumber"] == "" || !isValidStringInput(party["gstNumber"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.GST_NUMBER,
      message: 'Invalid GST Number',
    };
    errorItems.push(errorItem);
  }
  if (party && (party["panNumber"] == "" || !isValidStringInput(party["panNumber"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.PAN_NUMBER,
      message: 'Invalid PAN Number',
    };
    errorItems.push(errorItem);
  }
  if (party && (party["tinNumber"] == "" || !isValidStringInput(party["tinNumber"]))) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.TIN_NUMBER,
      message: 'Invalid TIN Number',
    };
    errorItems.push(errorItem);
  }
  if (prefPayment && !isValidStringInput(prefPayment["prefValue"])) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.O_PAYMENT_TERM,
      message: 'Invalid Preference Value',
    };
    errorItems.push(errorItem);
  }
  if (prefTerms && !isValidStringInput(prefTerms["prefValue"])) {
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.TnC,
      message: 'Invalid Terms and Conditions',
    };
    errorItems.push(errorItem);
  }
  if (roValue && !isValidStringInput(roValue["prefValue"])){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.REPEAT_ORDER,
      message: 'Invalid Repeat Order Value',
    };
    errorItems.push(errorItem);
  }
  if(poSequence && !isValidStringInput(poSequence?.["sequence"]?.["prefixValue"])){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX,
      message: 'Invalid Prefix Value'
    }
    errorItems.push(errorItem);
  }
  else if(poSequence?.["sequence"]?.["prefix"].replaceAll(" ","").length===0 || poSequence?.["sequence"]?.["prefix"]?.replaceAll(" ","").length>20){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.PO_PREFIX,
      message: 'Prefix should be greater than 0 and less than 20 characters'
    }
    errorItems.push(errorItem);
  }
  if(poSequence && isNaN(Number(poSequence?.["sequence"]?.["currentIndex"]))){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.PO_CURRENT,
      message: 'Invalid Current Value.It can be a number only'
    }
    errorItems.push(errorItem);
  }
  if(poSequence && isNaN(Number(poSequence?.["sequence"]?.["startIndex"]))){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.PO_START,
      message: 'Invalid Start Value. It can be a number only'
    }
    errorItems.push(errorItem);
  }
  if (prefBid && isNaN(prefBid["prefValue"])){
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.DEFAULT_BID_DATE,
      message: 'Invalid Defult Bid Value',
    };
    errorItems.push(errorItem);
  }
  else if(prefBid && (prefBid["prefValue"]<2 || prefBid["prefValue"]>365)){
    console.log(prefBid["prefValue"]);
    const errorItem = {
      elementId: CONFIGURATION_CONSTANTS.INPUT_ID.DEFAULT_BID_DATE,
      message: 'Invalid Defult Bid Value: Range should be between 2 and 365 days',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

export function validateSellerProfile(requestObject: any){
  let errorItems: any[] = []
  if (requestObject && (requestObject["mobileNumber"] == "" || !isValidPhoneNumber(requestObject["mobileNumber"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.mobileNumber,
      message: 'Invalid Mobile Number',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["partyGroupName"] == "" || !isValidStringInput(requestObject["partyGroupName"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.partyGroupName,
      message: 'Invalid Organisation Name',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["address"] == "" || !isValidStringInput(requestObject["address"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.address,
      message: 'Invalid Address',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["state"] == "" || !isValidStringInput(requestObject["state"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.state,
      message: 'Invalid State',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["city"] == "" || !isValidStringInput(requestObject["city"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.city,
      message: 'Invalid City',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["pincode"] == "" || !isValidStringInput(requestObject["pincode"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.pincode,
      message: 'Invalid Pincode',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["emailAddress"] == "" || !validateEmail(requestObject["emailAddress"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.emailAddress,
      message: 'Invalid Email Address',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["personName"] == "" || !isValidStringInput(requestObject["personName"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.personName,
      message: 'Invalid Name',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && (requestObject["gstNumber"] == "" || !isValidGSTIN(requestObject["gstNumber"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.gstNumber,
      message: 'Invalid GST Number',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && requestObject["panNumber"]!=="" && (!isValidStringInput(requestObject["panNumber"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.panNumber,
      message: 'Invalid PAN Number',
    };
    errorItems.push(errorItem);
  }
  if (requestObject && requestObject["tinNumber"]!=="" && (!isValidStringInput(requestObject["tinNumber"]))) {
    const errorItem = {
      elementId: SELLER_PROFILE.tinNumber,
      message: 'Invalid TIN Number',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

export function validateBusinessDetails(requestObject:any, purpose: string){
  const errorItems = []
  const partyGroupName = requestObject[BUSINESS_DETAILS.partyGroupName]
  const personName = requestObject[BUSINESS_DETAILS.personName]
  const address= requestObject[BUSINESS_DETAILS.address]
  const pincode = requestObject[BUSINESS_DETAILS.pincode]
  const mobileNumber = requestObject[BUSINESS_DETAILS.mobileNumber]
  const emailAddress = requestObject[BUSINESS_DETAILS.emailAddress]
  const password = requestObject[BUSINESS_DETAILS.password]
  const gstNumber = requestObject[BUSINESS_DETAILS.gstNumber]
  const panNumber = requestObject[BUSINESS_DETAILS.panNumber]
  const tinNumber = requestObject[BUSINESS_DETAILS.tinNumber]
  const city = requestObject[BUSINESS_DETAILS.city]
  const state = requestObject[BUSINESS_DETAILS.state]
  
  if (
    city == '' || !isValidStringInput(city) || !s_a[state_arr.indexOf(state) + 1]
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.city,
      message: 'Invalid City Name',
    };
    errorItems.push(errorItem);
  }
  if (
    state == '' || !isValidStringInput(state) || !state_arr.includes(state)
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.state,
      message: 'Invalid State Name',
    };
    errorItems.push(errorItem);
  }
  if (
    partyGroupName == '' || !isValidStringInput(partyGroupName)
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.partyGroupName,
      message: 'Invalid Business Name',
    };
    errorItems.push(errorItem);
  }
  if (
    (personName == '' || !isValidStringInput(personName)) && purpose === "SignUp"
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.personName,
      message: 'Invalid Person Name',
    };
    errorItems.push(errorItem);
  }
  if (
    address == '' || !isValidStringInput(address)
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.address,
      message: 'Invalid Address',
    };
    errorItems.push(errorItem);
  }
  if (
    pincode == '' || !isValidStringInput(pincode)
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.pincode,
      message: 'Invalid Pincode',
    };
    errorItems.push(errorItem);
  }
  if (
    mobileNumber == '' || !isValidPhoneNumber(mobileNumber)
  ) {
    const errorItem = {
      elementId: BUSINESS_DETAILS.mobileNumber,
      message: 'Invalid Mobile Number',
    };
    errorItems.push(errorItem);
  }
  // if (
  //   emailAddress == '' || !isValidStringInput(emailAddress) || !validateEmail(emailAddress)
  // ) {
  //   const errorItem = {
  //     elementId: BUSINESS_DETAILS.emailAddress,
  //     message: 'Invalid Email Address',
  //   };
  //   errorItems.push(errorItem);
  // }

  return errorItems;
}


export function isValidStringInput(input: string) {
  // Check for script injection
  const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  if (scriptRegex.test(input)) {
    return false; // Contains script tag
  }

  // Check for SQL injection
  const sqlKeywords = [
    'select',
    'insert',
    'update',
    'delete',
    'drop',
    'create',
    'alter',
  ];
  for (const keyword of sqlKeywords) {
    const regex = new RegExp('\\b' + keyword + '\\b', 'i');
    if (regex.test(input)) {
      return false; // Contains SQL keyword
    }
  }

  // Input passed all checks
  return true;
}

export function validateRateContract(contractObject: any) {
  const rateContractName = contractObject.rateContractName;
  const contractItems = contractObject.items;
  const validTillDate = contractObject.validTillDate;
  const rateContractAmountLimit = contractObject.rateContractAmountLimit

  const errorItems = [];
  if (rateContractName === '' || !isValidStringInput(rateContractName)) {
    const errorItem = {
      elementId: 'rateContractName',
      message: 'Invalid Rate Contract Name',
    };
    errorItems.push(errorItem);
  }

  if (validTillDate === '') {
    const errorItem = {
      elementId: 'validTillDate',
      message: 'Invalid Validity Date',
    };
    errorItems.push(errorItem);
  }

  if (rateContractAmountLimit === "" || isNaN(rateContractAmountLimit)) {
    const errorItem = {
      elementId: 'rateContractAmountLimit',
      message: 'Invalid Amount',
    };
    errorItems.push(errorItem);
  }
  
  if (contractItems && contractItems.length > 0) {
    let hasValidValueItems = false;
    contractItems.forEach((contractItem: any, index: number) => {

      // const quantSplit = contractItem?.quantity?.toString()?.split('.');
      const ppuSplit = contractItem?.pricePerUnit?.toString()?.split('.');

      if (!contractItem.item  || contractItem.item.trim() == "") {
        const errorItem = {
          elementId: `item_${index}`,
          message: 'Invalid item',
        };
        errorItems.push(errorItem);
      }
      else if (contractItem.pricePerUnit <= 0 && contractItem.gst > 0) {
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      } else if (contractItem.gst < 0 && contractItem.pricePerUnit > 0) {
        const errorItem = {
          elementId: `gst_${index}`,
          message: 'Invalid item GST',
        };
        errorItems.push(errorItem);
      }
      else if(contractItem.pricePerUnit > 0 && contractItem.gst>=0){
        hasValidValueItems = true
      }
      if ( isNaN(contractItem?.pricePerUnit) || (ppuSplit?.length > 1 && ppuSplit[1].length === 0) ){
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      }
    });
  }
  else {
    const errorItem = {
      elementId: 'itemsSize',
      message: 'Atleast One Item is Required',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}

const checkValidItemType = (itemType:any,validCategories:any)=> {
  if(itemType === "") return true; // We are now allowing categories to be optional
  for (let category of validCategories) {
    if (category._id === itemType) return true;
  }
  return false
}
// Common UOM aliases (plurals / abbreviations / spellings) mapped to the
// canonical UOM value stored in the master (_id). Keys are matched after
// upper-casing and stripping spaces and dots, e.g. "Sq. Ft" -> "SQFT".
export const UOM_ALIASES: { [key: string]: string } = {
  BAG: "Bags",
  FT: "Feet", FOOT: "Feet",
  SQFT: "SQF", SFT: "SQF",
  SQMT: "SQM", SQMTR: "SQM",
  METER: "MTR", METRE: "MTR", RMT: "MTR", RM: "MTR",
  LITRE: "LTR", LITER: "LTR", LT: "LTR",
  KGS: "KG", KILOGRAM: "KG",
  GRAM: "Gm", GRAMS: "Gm", GMS: "Gm",
  NO: "NOS", NUMBER: "NOS", NUMBERS: "NOS", UNIT: "NOS", UNITS: "NOS", EACH: "NOS", EA: "NOS",
  PC: "PCS", PIECE: "PCS", PIECES: "PCS",
  PACKET: "Pkt", PACKETS: "Pkt",
  BOXES: "Box",
  PAIRS: "Pair", PR: "Pair",
  DOZ: "Dozen", DZ: "Dozen",
  ROLLS: "Roll",
  REAM: "Rim", REAMS: "Rim",
  SETS: "Set",
  TONNE: "Ton", TONNES: "Ton", TONS: "Ton",
  BUNDLES: "Bundle", BDL: "Bundle",
  DAY: "Days",
  QUANTITY: "Qty",
};

// Resolve a raw UOM string (from an uploaded sheet / GenAI extraction) to the
// canonical UOM in `canonicalNames`, tolerating case, spaces/dots and the
// aliases above. Returns "" when the value can't be confidently mapped.
export const normalizeUOM = (raw: any, canonicalNames: string[]): string => {
  if (raw === null || raw === undefined) return "";
  const value = String(raw).trim();
  if (value === "") return "";
  const key = value.toUpperCase().replace(/[\s.]/g, "");
  const direct = canonicalNames.find(
    (name) => name.toUpperCase().replace(/[\s.]/g, "") === key
  );
  if (direct) return direct;
  const alias = UOM_ALIASES[key];
  if (alias && canonicalNames.includes(alias)) return alias;
  return "";
};

// The GenAI extractor sometimes echoes the prompt's JSON template example as a
// literal line item (e.g. itemName "Name of the item or product", UOM
// "Unit of measurement for quantity (choose from the list)"). Such rows are not
// real items and must be dropped before populating/validating the RFQ.
export const isPlaceholderRFQItem = (item: any): boolean => {
  if (!item) return true;
  const name = String(item.itemName ?? item.item ?? "").trim().toLowerCase();
  const uom = String(item.quantityUOM ?? "").trim().toLowerCase();
  return (
    name === "name of the item or product" ||
    uom === "unit of measurement for quantity (choose from the list)" ||
    uom.includes("choose from the list")
  );
};

const checkValidUOM = (UOM:any,validUOM:any)=> {
  const canonicalNames = (validUOM || []).map((uom: any) => uom._id);
  return normalizeUOM(UOM, canonicalNames) !== "";
}

export function isValidGSTIN(gst: string): boolean {
  const regex = /^([0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1})$/;
  return regex.test(gst);
}

function validateEmail(input:string) {
  // Regular expression for basic email validation
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(input);
};


export function isValidPhoneNumber(input:string) {
  const numberRegex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  if(numberRegex.test(input)){
    return true;
  }
}

export function validateInvoiceUpload(invoiceObject: any) {
  // const rateContractName = invoiceObject.rateContractName;
  const invoiceItems = invoiceObject.invoiceItems;
  const shippingAddress = invoiceObject.shippingAddress;
  const billingAddress = invoiceObject.billingAddress
  const errorItems = [];

  console.log(invoiceObject)

  if (!shippingAddress.address1 || !isValidStringInput(shippingAddress.address1) ) {
    const errorItem = {
      elementId: `shippingAddress.address1`,
      message: 'Invalid Address',
    };
    errorItems.push(errorItem);
  }
  if (!shippingAddress.state || !isValidStringInput(shippingAddress.state) ) {
    const errorItem = {
      elementId: `shippingAddress.state`,
      message: 'Invalid State',
    };
    errorItems.push(errorItem);
  }
  if (!shippingAddress.city || !isValidStringInput(shippingAddress.city) ) {
    const errorItem = {
      elementId: `shippingAddress.city`,
      message: 'Invalid City',
    };
    errorItems.push(errorItem);
  }
  if (!shippingAddress.pincode || !isValidStringInput(shippingAddress.pincode) ) {
    const errorItem = {
      elementId: `shippingAddress.pincode`,
      message: 'Invalid Pincode',
    };
    errorItems.push(errorItem);
  }
  if (!billingAddress.address1 || !isValidStringInput(billingAddress.address1) ) {
    const errorItem = {
      elementId: `billingAddress.address1`,
      message: 'Invalid Address',
    };
    errorItems.push(errorItem);
  }
  if (!billingAddress.state || !isValidStringInput(billingAddress.state) ) {
    const errorItem = {
      elementId: `billingAddress.state`,
      message: 'Invalid State',
    };
    errorItems.push(errorItem);
  }
  if (!billingAddress.city || !isValidStringInput(billingAddress.city) ) {
    const errorItem = {
      elementId: `billingAddress.city`,
      message: 'Invalid City',
    };
    errorItems.push(errorItem);
  }
  if (!billingAddress.pincode || !isValidStringInput(billingAddress.pincode) ) {
    const errorItem = {
      elementId: `billingAddress.pincode`,
      message: 'Invalid Pincode',
    };
    errorItems.push(errorItem);
  }
  
  if (invoiceItems && invoiceItems.length > 0) {
    let hasValidValueItems = false;
    invoiceItems.forEach((invoiceItem: any, index: number) => {

      const ppuSplit = invoiceItem?.finalUnitPrice?.toString()?.split('.');

      if (!invoiceItem.item  || invoiceItem.item.trim() == "") {
        const errorItem = {
          elementId: `item_${index}`,
          message: 'Invalid item',
        };
        errorItems.push(errorItem);
      }
      if (invoiceItem.finalUnitPrice <= 0 && invoiceItem.gst > 0) {
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      } else if (invoiceItem.gst < 0 && invoiceItem.finalUnitPrice > 0) {
        const errorItem = {
          elementId: `gst_${index}`,
          message: 'Invalid item GST',
        };
        errorItems.push(errorItem);
      }
      else if(invoiceItem.finalUnitPrice > 0 && invoiceItem.gst>=0){
        hasValidValueItems = true
      }
      if ( isNaN(invoiceItem?.finalUnitPrice) || (ppuSplit?.length > 1 && ppuSplit[1].length === 0) ){
        const errorItem = {
          elementId: `pricePerUnit_${index}`,
          message: 'Invalid item unit price',
        };
        errorItems.push(errorItem);
      }
      if ( !invoiceItem?.hsnCode || ![2,4,6,8].includes(invoiceItem?.hsnCode.length)){
        const errorItem = {
          elementId: `hsnCode_${index}`,
          message: 'Invalid HSN Code',
        };
        errorItems.push(errorItem);
      }
      if (!invoiceItem.quantity || invoiceItem.quantity <= 0) {
        const errorItem = {
          elementId: `quantity_${index}`,
          message: 'Invalid Quantity',
        };
        errorItems.push(errorItem);
      }
      if (!isValidStringInput(invoiceItem.quantityUOM) ) {
        const errorItem = {
          elementId: `quantityUOM_${index}`,
          message: 'Invalid UOM',
        };
        errorItems.push(errorItem);
      }
    });
  }
  else {
    const errorItem = {
      elementId: 'itemsSize',
      message: 'Atleast One Item is Required',
    };
    errorItems.push(errorItem);
  }
  return errorItems;
}